export enum ApproverType {
  CHIEF = 'CHIEF',
  CHIEF_AND_DEPUTY = 'CHIEF_AND_DEPUTY',
  COST_CENTRE_RESPONSIBLE = 'COST_CENTRE_RESPONSIBLE',
  COST_CENTRE_RESPONSIBLE_AND_DEPUTY = 'COST_CENTRE_RESPONSIBLE_AND_DEPUTY',
  DEPARTMENT_CHIEF = 'DEPARTMENT_CHIEF',
  DEPARTMENT_CHIEF_AND_DEPUTY = 'DEPARTMENT_CHIEF_AND_DEPUTY',
  MAIN_DEPARTMENT_CHIEF = 'MAIN_DEPARTMENT_CHIEF',
  MAIN_DEPARTMENT_CHIEF_AND_DEPUTY = 'MAIN_DEPARTMENT_CHIEF_AND_DEPUTY',
  DIRECTOR = 'DIRECTOR',
  DIRECTOR_AND_DEPUTY = 'DIRECTOR_AND_DEPUTY',
  DESIGNATED_APPROVER = 'DESIGNATED_APPROVER',
  APPROVER_GROUP = 'APPROVER_GROUP',
  SELECTED_APPROVER = 'SELECTED_APPROVER'
}

export function getAllApproverTypeValues(): ApproverType[] {
  return Object.values(ApproverType);
}

export function getLocalizedNameOfApproverType(approverType: ApproverType): string {
  switch (approverType) {
    case ApproverType.CHIEF:
      return 'Vorgesetzte/r';
    case ApproverType.CHIEF_AND_DEPUTY:
      return 'Vorgesetzte/r oder Stellvertreter/in';
    case ApproverType.COST_CENTRE_RESPONSIBLE:
      return 'Kostenstellenverantwortliche';
    case ApproverType.COST_CENTRE_RESPONSIBLE_AND_DEPUTY:
      return 'Kostenstellenverantwortliche/r oder Stellvertreter/in';
    case ApproverType.DEPARTMENT_CHIEF:
      return 'Abteilungsleiter/in';
    case ApproverType.DEPARTMENT_CHIEF_AND_DEPUTY:
      return 'Abteilungsleiter/in oder Stellvertreter/in';
    case ApproverType.MAIN_DEPARTMENT_CHIEF:
      return 'HA Leiter/in';
    case ApproverType.MAIN_DEPARTMENT_CHIEF_AND_DEPUTY:
      return 'HA Leiter/in oder Stellvertreter/in';
    case ApproverType.DIRECTOR:
      return 'Direktor/in';
    case ApproverType.DIRECTOR_AND_DEPUTY:
      return 'Direktor/in oder Stellvertreter/in';
    case ApproverType.DESIGNATED_APPROVER:
      return 'Festgelegte/r Genehmiger/in';
    case ApproverType.APPROVER_GROUP:
      return 'Festgelegte Genehmigergruppe';
    case ApproverType.SELECTED_APPROVER:
      return 'Ausgewählte/r Genehmiger/in';
  }
}
